import dynamic from 'next/dynamic';

export const GenericModal = dynamic(() => import('./GenericModal').then(module => module.GenericModal));
